import { render } from "./FooterCom.vue?vue&type=template&id=66262458&scoped=true"
const script = {}

import "./FooterCom.vue?vue&type=style&index=0&id=66262458&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66262458"]])

export default __exports__